import { Box, Grid } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import giftApis from "src/api/gifts"
import { GIFTS } from "src/constants/queryKeys"
import { theme } from "src/providers/ThemeProvider"
import RightNavbar from "../RightNavbar"
import GiftBoxSlider from "./GiftBoxSlide"
import Introduce from "./Introduce"

const SpecialOffers = () => {
  const { data: listGifts } = useQuery({
    queryKey: [GIFTS],
    queryFn: () =>
      giftApis.getGifts({
        pageIndex: 0,
        pageSize: 6,
      }),
  })

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={6}
      position="relative"
      alignItems="center"
      sx={theme => ({
        padding: theme.spacing(4, 2),
        backgroundImage:
          "linear-gradient(#5ed3db,#85d5d2,#b1d8c9,#d2dac3,#ebdbbe,#f9dcbb,#ffddba)",
      })}
    >
      <RightNavbar />
      <img src="/assets/images/kitchen_logo.png" alt="logo" />
      <>
        <Box
          width="100%"
          textAlign="center"
          sx={{
            [theme.breakpoints.down(600)]: {
              "& > img": {
                width: "85%",
              },
            },
          }}
        >
          <img
            src="/assets/images/tich_tem_doi_qua.png"
            alt="tich_tem_doi_qua"
          />
        </Box>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          sx={{
            width: "100%",
            overflow: "hidden",
          }}
        >
          {!!listGifts && !!listGifts.length && (
            <GiftBoxSlider data={listGifts} />
          )}
        </Grid>
      </>
      <Introduce />
    </Box>
  )
}

export default SpecialOffers
